<template>
  <div class="stats-page">
    <!-- <h2>统计页面</h2>
    <p>当前 Token: {{ currency }}</p>
    <p>统计日期: {{ statsDate }}</p>
     -->
    <div class="stats-content">
      <!-- 第一部分：所有 API 的统计 -->
      <!-- 合约资金变化 -->
      <div class="section" v-if="type === '2'">
        <h3>{{ statsDate }}资金变化</h3>
        <!-- <p>日期是当天零点</p> -->
        <div class="summary-cards">
          <div class="summary-card">
            <div class="card-header">
              <span class="card-title">{{ dayDate }}账户总权益（u）</span>
            </div>
            <div class="card-value">{{ totalUsdtBalance }}</div>
            <span class="change-label">较{{ statsDate }}变化</span>
            <div class="card-change" :class="totalUsdtChange >= 0 ? 'positive' : 'negative'">
              {{ totalUsdtChange >= 0 ? '+' : '' }}{{ totalUsdtChange }}
            </div>
          </div>
          <div class="summary-card">
            <div class="card-header">
              <span class="card-title">{{ dayDate }}总维持保证金</span>
            </div>
            <div class="card-value">{{ totalMargin }}</div>
            <span class="change-label">较{{ statsDate }}变化</span>
            <div class="card-change" :class="totalMarginChange >= 0 ? 'positive' : 'negative'">
              {{ totalMarginChange >= 0 ? '+' : '' }}{{ totalMarginChange }}
            </div>
          </div>
        </div>
      </div>

      <!-- 现货资金变化 -->
      <div class="section" v-if="type === '1'">
        <h3>{{ statsDate }}资金变化</h3>
        <!-- <p>日期是当天零点</p> -->
        <div class="summary-cards">

          <!-- 可用usdt -->
          <div class="summary-card">
            <div class="card-header">
              <span class="card-title">{{ dayDate }}总可用USDT</span>
            </div>
            <div class="card-value">{{ spotAvailUsdt }}</div>
            <span class="change-label">较{{ statsDate }}变化</span>
            <div class="card-change" :class="spotAvailUsdtChange >= 0 ? 'positive' : 'negative'">
              {{ spotAvailUsdtChange >= 0 ? '+' : '' }}{{ spotAvailUsdtChange }}
            </div>
          </div>
          <!-- 可用token -->
          <div class="summary-card">
            <div class="card-header">
              <span class="card-title">{{ dayDate }}总可用{{ currency }}</span>
            </div>
            <div class="card-value">{{ spotAvailToken }}</div>
            <span class="change-label">较{{ statsDate }}变化</span>
            <div class="card-change" :class="spotAvailTokenChange >= 0 ? 'positive' : 'negative'">
              {{ spotAvailTokenChange >= 0 ? '+' : '' }}{{ spotAvailTokenChange }}
            </div>
          </div>
          <!-- 冻结usdt -->
          <div class="summary-card">
            <div class="card-header">
              <span class="card-title">{{ dayDate }}总冻结USDT</span>
            </div>
            <div class="card-value">{{ spotHoldUsdt }}</div>
            <span class="change-label">较{{ statsDate }}变化</span>
            <div class="card-change" :class="spotHoldUsdtChange >= 0 ? 'positive' : 'negative'">
              {{ spotHoldUsdtChange >= 0 ? '+' : '' }}{{ spotHoldUsdtChange }}
            </div>
          </div>
          <!-- 冻结token -->
          <div class="summary-card">
            <div class="card-header">
              <span class="card-title">{{ dayDate }}总冻结{{ currency }}</span>
            </div>
            <div class="card-value">{{ spotHoldToken }}</div>
            <span class="change-label">较{{ statsDate }}变化</span>
            <div class="card-change" :class="spotHoldTokenChange >= 0 ? 'positive' : 'negative'">
              {{ spotHoldTokenChange >= 0 ? '+' : '' }}{{ spotHoldTokenChange }}
            </div>
          </div>
          <!-- 总usdt -->
          <div class="summary-card">
            <div class="card-header">
              <span class="card-title">{{ dayDate }}总USDT</span>
            </div>
            <div class="card-value">{{ totalUsdtBalance }}</div>
            <span class="change-label">较{{ statsDate }}变化</span>
            <div class="card-change" :class="totalUsdtChange >= 0 ? 'positive' : 'negative'">
              {{ totalUsdtChange >= 0 ? '+' : '' }}{{ totalUsdtChange }}
            </div>
          </div>
          <!-- 总token -->
          <div class="summary-card">
            <div class="card-header">
              <span class="card-title">{{ dayDate }}总{{ currency }}</span>
            </div>
            <div class="card-value">{{ totalTokenBalance }}</div>
            <span class="change-label">较{{ statsDate }}变化</span>
            <div class="card-change" :class="totalTokenChange >= 0 ? 'positive' : 'negative'">
              {{ totalTokenChange >= 0 ? '+' : '' }}{{ totalTokenChange }}
            </div>
          </div>

        </div>
      </div>

      <!-- 第二部分：各个 API 的分别统计 -->
      <div class="section">
        <h3>成交明细</h3>
        <div class="api-stats-table">
          <el-form :inline="true" :model="tradeForm" class="demo-form-inline"
            style="display: flex; flex-wrap: wrap; align-items: center;">
            <el-form-item label="方向" style="margin-right: 10px;">
              <el-select v-model="tradeForm.direction" placeholder="请选择" style="width: 100px;">
                <el-option label="全部" value=""></el-option>
                <el-option label="买入" value="buy"></el-option>
                <el-option label="卖出" value="sell"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间范围" style="margin-right: 10px;">
              <el-date-picker v-model="tradeForm.timeRange" type="datetimerange" range-separator="-"
                start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 380px;"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59'
                }"></el-date-picker>
            </el-form-item>
            <el-form-item style="margin-right: 0;">
              <el-button type="primary" @click="searchTrade" style="padding: 9px 15px;">查询</el-button>
              <el-button @click="resetTradeForm" style="padding: 9px 15px;">重置</el-button>
              <el-button @click="exportTotal()" style="padding: 9px 15px;">导出</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="tradeData" border>
            <!-- <el-table-column prop="id" label="成交编号"></el-table-column> -->
            <el-table-column prop="api" label="api"></el-table-column>
            <el-table-column prop="time" label="成交时间"></el-table-column>
            <el-table-column prop="pair" label="交易对" width="120"></el-table-column>
            <el-table-column prop="direction" label="方向" width="80"></el-table-column>
            <el-table-column prop="amount" label="成交数量"></el-table-column>
            <el-table-column prop="price" label="成交价格"></el-table-column>
            <el-table-column prop="total" label="成交金额"></el-table-column>
            <el-table-column prop="fee" label="手续费"></el-table-column>
            <el-table-column prop="feeCurrency" label="计费币种" width="80"></el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination @size-change="handleTradeSizeChange" @current-change="handleTradeCurrentChange"
            :current-page="tradePage" :page-sizes="[5, 10, 20, 50]" :page-size="tradePageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="tradeTotal" class="pagination"></el-pagination>
        </div>
      </div>

      <!-- 第三部分：各个 API 的总计 -->
      <div class="section">
        <h3>{{ currency }}项目总计</h3>
        <div class="api-stats-table">
          <!-- 总计表格 -->
          <el-table :data="tradeTotalData" border>
            <el-table-column prop="amount" label="总成交数量"></el-table-column>
            <el-table-column prop="price" label="平均成交价格"></el-table-column>
            <el-table-column prop="total" label="总成交金额"></el-table-column>
            <el-table-column prop="fee" :label="'总手续费（' + currency + '）'"></el-table-column>
            <el-table-column prop="uFee" :label="'总手续费（USDT）'"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "./api";
import exAccounts from "@/proto/exAccounts_pb";
import exQryOrders from "@/proto/exQryOrders_pb";
import exQryFills from "@/proto/exQryFills_pb";
import exQryHolds from "@/proto/exQryHolds_pb";
import dbPermission from "@/proto/dbPermission_pb";
import utils from "../lib/utils";
import Decimal from "decimal.js";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
export default {
  name: "StatsPage",
  data() {
    return {
      currency: "",
      type: "", // 1是现货总计，2是合约总计
      dayDate: "", // 今天
      statsDate: "", // 昨天
      currentPage: 1,
      pageSize: 10,
      total: 8,
      // 总统计数据
      totalTokenBalance: 0,
      totalUsdtBalance: 0,
      totalTokenChange: 0,
      totalUsdtChange: 0,
      totalFee: "0",
      totalFeeChange: 0,
      totalMargin: 0,
      totalMarginChange: 0,
      // 现货资金数据
      spotAvailToken: 0,
      spotAvailTokenChange: 0,
      spotHoldToken: 0,
      spotHoldTokenChange: 0,
      spotAvailUsdt: 0,
      spotAvailUsdtChange: 0,
      spotHoldUsdt: 0,
      spotHoldUsdtChange: 0,
      // API 统计数据
      apiStatsData: [],
      // api
      apiChildren: [],
      tradeForm: {
        id: "",
        pair: "",
        direction: "",
        type: "",
        timeRange: []
      },
      // 成交数据
      tradeOriginData: [],
      tradeData: [],
      tradeTotalData: [],
      tradePage: 1,
      tradePageSize: 5,
      tradeTotal: 0
    };
  },
  async created() {
    let nowDate = new Date();
    let endDate = utils.dateFormat(nowDate.getTime());
    let startDate = utils.dateFormat(nowDate.getTime() - 1 * 24 * 60 * 60 * 1000);
    this.tradeForm.timeRange = [startDate, endDate];
    this.currency = this.$route.params.token || "LLL";
    this.type = this.$route.params.type || "1";
    // 设置统计日期为当天
    const yesterday = new Date();
    this.dayDate = yesterday.toLocaleDateString("zh-CN");
    yesterday.setDate(yesterday.getDate() - 1);
    this.statsDate = yesterday.toLocaleDateString("zh-CN");
    // this.generateMockData();
    await this.getMenuData();
    await this.getTradeData();
    if (this.type === "1") {
      // await this.getAllAmount();
      await this.getSpotYeData();
    } else if (this.type === "2") {
      await this.getFuYeData();
    }
    this.tradeForm.pair = this.currency + "USDT";
  },
  methods: {
    // 获取这个项目的所有api
    async getMenuData() {
      var data = {
        uid: localStorage.getItem("userName"),
        apiType: this.type
      };
      let res = await API.getMenu(data);
      if (res.data.errcode === 0) {
        var buffer = res.data.buffer;
        var message =
          dbPermission.DbPermissionList.deserializeBinary(buffer);
        message.getPermissionsList().forEach((element) => {
          // 币种
          var token = element.getToken();
          if (token === this.currency) {
            var apiArray = [];
            element.getApisList().forEach((api) => {
              var apiObj = {
                id: token + "-" + api.getAlias(),
                baseCurrency: element.getToken(),
                apiId: api.getId(),
                label: api.getAlias(),
                exchange: api.getExchange(),
                apiType: api.getApitype()
              };
              var symbolArray = [];
              api.getSymbolsList().forEach((symbol) => {
                var symbolObj = {
                  // id: token + "-" + api.getAlias() + "-" + symbol,
                  // token: token,
                  label: symbol,
                  symbol: symbol,
                  // exchange: api.getExchange(),
                  // apiId: api.getId(),
                  // alias: api.getAlias()
                };
                symbolArray.push(symbolObj);
              });
              apiObj.children = symbolArray;
              apiArray.push(apiObj);
            });
            this.apiChildren = apiArray;
          }
        });
      } else {
        this.loading.close();
        this.$message.error(res.data.errcode + ":" + res.data.errmsg);
        if (res.data.errcode === 3005) {
          // 无效的登录凭证
          this.$router.push("/login");
        }
      }
    },
    // 成交数据
    async getTradeData() {
      let pageSizee = 1000;
      let startAt = new Date(this.tradeForm.timeRange[0]).getTime();
      let endAt = new Date(this.tradeForm.timeRange[1]).getTime();

      var fillsDataArray = [];
      for (let e of this.apiChildren) {
        var data = {
          uid: localStorage.getItem("userName"),
          apiId: e.apiId,
          exchange: Number(e.exchange),
          symbol: this.currency + "USDT",
          side: "",
          currentPage: this.tradePage.toString(),
          pageSize: pageSizee + "",
          startAt: startAt,
          endAt: endAt,
          tradeType: "TRADE"
        };
        let res = await API.getFills(data);
        if (res.data.errcode === 0) {
          var buffer = res.data.buffer;
          var message = exQryFills.ExQryFills.deserializeBinary(buffer);
          var fillsData = message.getData();
          fillsData.getItemsList().forEach((element) => {
            var data = {
              api: e.apiId,
              pair: element.getSymbol(), // 交易对
              tradeId: element.getTradeid(), // 交易id
              // tradeIntId: element.getTradeintid(),
              id: element.getOrderid(), // 订单id
              direction: element.getSide().toLowerCase(), // buy/sell
              price: element.getPrice(), // 订单价格
              amount: element.getSize(), // 下单数量
              total: element.getFunds(), // 下单金额
              fee: element.getFee(), // 手续费
              // feeRate: element.getFeerate(), // 手续费率
              feeCurrency: element.getFeecurrency(), // 计手续费币种
              type: element.getType().toLowerCase(), // limit 或 market
              time:
                element.getCreatedat() === 0
                  ? ""
                  : utils.dateFormat(element.getCreatedat()), // 创建时间
              // tradeType: element.getTradetype(), // 交易类型: TRADE, MARGIN_TRADE
              // ordercreateAt: ""
            };

            // 处理成交金额
            let fund = new Decimal(element.getPrice()).mul(new Decimal(element.getSize()));
            data.total = fund.toNumber();
            fillsDataArray.push(data);
          });
        } else {
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            // 无效的登录凭证
            this.$router.push("/login");
          }
          if (res.data.errcode === 4004) {
            this.tradePage = this.tradePage - 1;
          }
        }
        // 处理数据
        // 过滤买入卖出
        if (this.tradeForm.direction) {
          fillsDataArray = fillsDataArray.filter((r) => {
            let row = r.direction;
            return row.includes(this.tradeForm.direction);
          });
        }

        this.tradeOriginData = fillsDataArray;

        this.tradeData = [];
        var fillLen = fillsDataArray.length;
        this.tradeTotal = fillLen;
        let pageSize = this.tradePageSize;
        if (fillLen > pageSize) {
          let start = (this.tradePage.toString() - 1) * pageSize;
          let end = this.tradePage.toString() * pageSize;
          this.tradeData = fillsDataArray.slice(start, end);
        } else {
          this.tradeData = fillsDataArray;
        }
        this.getTradeDataTotal();
      }
    },
    // 计算总计
    getTradeDataTotal() {
      this.tradeTotalData = [];
      let totalAmount = new Decimal(0);
      let avgPrice = new Decimal(0);
      let totalTotal = new Decimal(0);
      let totalFee = new Decimal(0);
      let totalUFee = new Decimal(0);
      let tradeLength = new Decimal(this.tradeOriginData.length);
      for (let item of this.tradeOriginData) {
        totalAmount = totalAmount.add(new Decimal(item.amount));
        avgPrice = avgPrice.add(new Decimal(item.price));
        totalTotal = totalTotal.add(new Decimal(item.total));
        // 计算手续费
        if (item.feeCurrency === this.currency) {
          totalFee = totalFee.add(new Decimal(item.fee));
        }
        else {
          totalUFee = totalUFee.add(new Decimal(item.fee));
        }
      }
      let data = {
        amount: totalAmount.toNumber(),
        price: avgPrice.div(tradeLength).toNumber().toFixed(6),
        total: totalTotal.toNumber(),
        fee: utils.toNonExponential(totalFee.toNumber()),
        uFee: utils.toNonExponential(totalUFee.toNumber())
      };
      this.tradeTotalData.push(data);
    },
    // 按钮
    searchTrade() {
      this.tradePage = 1;
      this.getTradeData();
    },
    resetTradeForm() {
      this.tradeForm = { id: "", pair: this.currency + "USDT", direction: "", type: "", timeRange: [] };
      this.tradePage = 1;
      this.getTradeData();
    },
    // 分页相关
    handleTradeSizeChange(val) {
      this.tradePageSize = val;
      this.tradePage = 1;
      this.getTradeData();
    },
    handleTradeCurrentChange(val) {
      let start = (val - 1) * this.tradePageSize;
      let end = val * this.tradePageSize;
      this.tradeData = this.tradeOriginData.slice(start, end);
      this.getTradeDataTotal();
    },
    // 总资金查询
    async getAllAmount() {
      for (let e of this.apiChildren) {
        // 先查u
        var balanceData = {
          uid: localStorage.getItem("userName"),
          apiId: e.apiId,
          currency: "",
          type: "",
          exchange: Number(e.exchange)
        };
        let balanceRes = await API.getAccounts(balanceData);
        if (balanceRes.data.errcode === 0) {
          var buffer = balanceRes.data.buffer;
          var message = exAccounts.ExAccounts.deserializeBinary(buffer);
          var accountTableArray = [];

          message.getDataList().forEach((element) => {
            var data = {
              currency: element.getCurrency(),
              type: element.getType(),
              balance: element.getBalance(),
              available: element.getAvailable(),
              holds: element.getHolds()
            };
            accountTableArray.push(data);
          });
          // 去重
          var transferTableArray = [];
          var obj = {};
          for (var i = 0; i < accountTableArray.length; i++) {
            if (!obj[accountTableArray[i].currency]) {
              transferTableArray.push(accountTableArray[i]);
              obj[accountTableArray[i].currency] = true;
            }
          }
          for (let e of accountTableArray) {
            // console.log(e)
            if (e.currency === "USDT") {
              this.totalUsdtBalance = new Decimal(this.totalUsdtBalance).add(new Decimal(e.balance)).toNumber();
              this.spotAvailUsdt = new Decimal(this.spotAvailUsdt).add(new Decimal(e.available)).toNumber();
              this.spotHoldUsdt = new Decimal(this.spotHoldUsdt).add(new Decimal(e.holds)).toNumber();
            }
            if (e.currency === this.currency) {
              this.totalTokenBalance = new Decimal(this.totalTokenBalance).add(new Decimal(e.balance)).toNumber();
              this.spotAvailToken = new Decimal(this.spotAvailToken).add(new Decimal(e.available)).toNumber();
              this.spotHoldToken = new Decimal(this.spotHoldToken).add(new Decimal(e.holds)).toNumber();
            }
          }
        } else {
          this.$message.error(balanceRes.data.errcode + ":" + balanceRes.data.errmsg);
          if (balanceRes.data.errcode === 3005) {
            // 无效的登录凭证
            this.$router.push("/login");
          }
        }
        // 再查持仓里的持仓数量和保证金
        // var positionData = {
        //   uid: localStorage.getItem("userName"),
        //   apiId: e.apiId,
        //   exchange: Number(e.exchange),
        //   symbol: this.currency + "USDT"
        // };
        // let positionRes = await API.getHolds(positionData);
        // if (positionRes.data.errcode === 0) {
        //   var buffer = positionRes.data.buffer;
        //   var message = exQryHolds.ExHolds.deserializeBinary(buffer);
        //   // console.log("message=", message);
        //   // console.log("message=", JSON.stringify(message));
        //   // let holdsData = message.getDataList();
        //   message.getDataList().forEach((element) => {
        //     // var data = {
        //     //   symbol: element.getSymbol(),
        //     //   // holdId: element.getHoldid(),
        //     //   direction: element.getHoldside(),
        //     //   holdPrice: element.getHoldprice(),
        //     //   holdSz: element.getHoldsz(),
        //     //   openBal: element.getOpenbal(),
        //     //   // holdBal: element.getHoldbal(),
        //     //   // ccy: element.getCcy(),
        //     //   // cTime: element.getCtime(),
        //     //   // uTime: element.getUtime(),
        //     //   mgnMode: element.getMgnmode(),
        //     //   leverage: element.getLeverage(),
        //     //   liqPrice: element.getLiqprice()
        //     // };
        //     this.totalTokenBalance = new Decimal(this.totalTokenBalance).add(new Decimal(element.getHoldsz() || 0)).toNumber();
        //     this.totalMargin = new Decimal(this.totalMargin).add(new Decimal(element.getOpenbal() || 0)).toNumber();
        //   });
        // } else {
        //   this.$message.error(positionRes.data.errcode + ":" + positionRes.data.errmsg);
        //   if (positionRes.data.errcode === 3005) {
        //     // 无效的登录凭证
        //     this.$router.push("/login");
        //   }
        //   if (positionRes.data.errcode === 4004) {
        //     this.pageConfig.currentPage = this.pageConfig.currentPage - 1;
        //   }
        // }
      }
    },
    // 获取昨天的总计数据
    async getFuYeData() {
      let apiIds = [];
      for (let e of this.apiChildren) {
        apiIds.push(e.apiId);
      }
      // 获取昨天00：00：00的时间戳
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      const yesterday = new Date(now);
      yesterday.setDate(now.getDate() - 1);

      // 查询当天的
      var data = {
        uid: localStorage.getItem("userName"),
        apiIds: apiIds,
        dateTime: Math.floor(now.getTime() / 1000)
      };
      let res = await API.getAccountDaily(data);
      if (res.data.errcode === 0) {
        let usdtBalance = new Decimal(0);
        let marginBa = new Decimal(0);
        for (let item of res.data.list) {
          usdtBalance = usdtBalance.add(new Decimal(item.totalEquity));
          marginBa = marginBa.add(new Decimal(item.accountMaintMargin));
        }
        // 当天零点的总权益和总维持保证金
        this.totalUsdtBalance = usdtBalance.toNumber();
        this.totalMargin = marginBa.toNumber();
      } else {
        this.$message.error(res.data.errcode + ":" + res.data.errmsg);
        if (res.data.errcode === 3005) {
          // 无效的登录凭证
          this.$router.push("/login");
        }
        if (res.data.errcode === 4004) {
          this.pageConfig.currentPage = this.pageConfig.currentPage - 1;
        }
      }

      // 查询昨天的
      var yeData = {
        uid: localStorage.getItem("userName"),
        apiIds: apiIds,
        dateTime: Math.floor(yesterday.getTime() / 1000)
      };
      let yeRes = await API.getAccountDaily(yeData);
      if (yeRes.data.errcode === 0) {
        let usdtBalance = new Decimal(0);
        let marginBa = new Decimal(0);
        for (let item of yeRes.data.list) {
          usdtBalance = usdtBalance.add(new Decimal(item.totalEquity));
          marginBa = marginBa.add(new Decimal(item.accountMaintMargin));
        }
        // 计算今天减去昨天的差值
        this.totalUsdtChange = new Decimal(this.totalUsdtBalance).minus(usdtBalance).toNumber();
        this.totalMarginChange = new Decimal(this.totalMargin).minus(marginBa).toNumber();
      } else {
        this.$message.error(yeRes.data.errcode + ":" + yeRes.data.errmsg);
        if (yeRes.data.errcode === 3005) {
          // 无效的登录凭证
          this.$router.push("/login");
        }
        if (yeRes.data.errcode === 4004) {
          this.pageConfig.currentPage = this.pageConfig.currentPage - 1;
        }
      }
    },

    async getSpotYeData() {
      let apiIds = [];
      for (let e of this.apiChildren) {
        apiIds.push(e.apiId);
      }
      // 获取昨天00：00：00的时间戳
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      const yesterday = new Date(now);
      yesterday.setDate(now.getDate() - 1);

      // 查询当天的
      var data = {
        uid: localStorage.getItem("userName"),
        apiIds: apiIds,
        dateTime: Math.floor(now.getTime() / 1000)
      };
      let res = await API.getAccountDaily(data);
      if (res.data.errcode === 0) {
        let totalT = new Decimal(0);
        let availT = new Decimal(0);
        let holdT = new Decimal(0);
        let totalU = new Decimal(0);
        let availU = new Decimal(0);
        let holdU = new Decimal(0);
        for (let item of res.data.list) {
          totalT = totalT.add(new Decimal(item.total_t));
          availT = availT.add(new Decimal(item.avail_t));
          holdT = holdT.add(new Decimal(item.lock_t));
          totalU = totalU.add(new Decimal(item.total_u));
          availU = availU.add(new Decimal(item.avail_u));
          holdU = holdU.add(new Decimal(item.lock_u));
        }
        // 当天零点的总权益和总维持保证金
        this.totalTokenBalance = totalT.toNumber().toFixed(4);
        this.spotAvailToken = availT.toNumber().toFixed(4);
        this.spotHoldToken = holdT.toNumber().toFixed(4);
        this.totalUsdtBalance = totalU.toNumber().toFixed(4);
        this.spotAvailUsdt = availU.toNumber().toFixed(4);
        this.spotHoldUsdt = holdU.toNumber().toFixed(4);
      } else {
        this.$message.error(res.data.errcode + ":" + res.data.errmsg);
        if (res.data.errcode === 3005) {
          // 无效的登录凭证
          this.$router.push("/login");
        }
        if (res.data.errcode === 4004) {
          this.pageConfig.currentPage = this.pageConfig.currentPage - 1;
        }
      }

      // 查询昨天的
      var yeData = {
        uid: localStorage.getItem("userName"),
        apiIds: apiIds,
        dateTime: Math.floor(yesterday.getTime() / 1000)
      };
      let yeRes = await API.getAccountDaily(yeData);
      if (yeRes.data.errcode === 0) {
        let totalT = new Decimal(0);
        let availT = new Decimal(0);
        let holdT = new Decimal(0);
        let totalU = new Decimal(0);
        let availU = new Decimal(0);
        let holdU = new Decimal(0);
        for (let item of yeRes.data.list) {
          totalT = totalT.add(new Decimal(item.total_t));
          availT = availT.add(new Decimal(item.avail_t));
          holdT = holdT.add(new Decimal(item.lock_t));
          totalU = totalU.add(new Decimal(item.total_u));
          availU = availU.add(new Decimal(item.avail_u));
          holdU = holdU.add(new Decimal(item.lock_u));
        }
        this.totalTokenChange = new Decimal(this.totalTokenBalance).minus(totalT).toNumber().toFixed(4);
        this.spotAvailTokenChange = new Decimal(this.spotAvailToken).minus(availT).toNumber().toFixed(4);
        this.spotHoldTokenChange = new Decimal(this.spotHoldToken).minus(holdT).toNumber().toFixed(4);
        this.totalUsdtChange = new Decimal(this.totalUsdtBalance).minus(totalU).toNumber().toFixed(4);
        this.spotAvailUsdtChange = new Decimal(this.spotAvailUsdt).minus(availU).toNumber().toFixed(4);
        this.spotHoldUsdtChange = new Decimal(this.spotHoldUsdt).minus(holdU).toNumber().toFixed(4);
      } else {
        this.$message.error(yeRes.data.errcode + ":" + yeRes.data.errmsg);
        if (yeRes.data.errcode === 3005) {
          // 无效的登录凭证
          this.$router.push("/login");
        }
        if (yeRes.data.errcode === 4004) {
          this.pageConfig.currentPage = this.pageConfig.currentPage - 1;
        }
      }
    },

    // ------------------导出excel---------------------------------------------------------------------------------------------
    exportTotal() {
      const workbook = XLSX.utils.book_new();
      const worksheet = {};

      // 先写总计的表
      worksheet['A1'] = { v: '项目' };
      worksheet['B1'] = { v: this.currency };

      // 总资金
      if (this.type === "2") {
        // worksheet['B3'] = { v: `${this.currency}持仓数` };
        worksheet['C3'] = { v: '账户总权益' };
        worksheet['D3'] = { v: '总维持保证金' };
        worksheet['A4'] = { v: this.statsDate };
        // worksheet['B4'] = { v: this.totalTokenBalance };
        worksheet['C4'] = { v: this.totalUsdtBalance };
        worksheet['D4'] = { v: this.totalMargin };
      } else if (this.type === "1") {
        worksheet['B3'] = { v: `总${this.currency}` };
        worksheet['C3'] = { v: `总可用${this.currency}` };
        worksheet['D3'] = { v: `总冻结${this.currency}` };
        worksheet['E3'] = { v: `总USDT` };
        worksheet['F3'] = { v: `总可用USDT` };
        worksheet['G3'] = { v: `总冻结USDT` };
        worksheet['B4'] = { v: this.totalTokenBalance };
        worksheet['C4'] = { v: this.spotAvailToken };
        worksheet['D4'] = { v: this.spotHoldToken };
        worksheet['E4'] = { v: this.totalUsdtBalance };
        worksheet['F4'] = { v: this.spotAvailUsdt };
        worksheet['G4'] = { v: this.spotHoldUsdt };
      }

      worksheet['A8'] = { v: '总成交数量' };
      worksheet['B8'] = { v: '平均成交价格' };
      worksheet['C8'] = { v: '总成交金额' };
      worksheet['D8'] = { v: '总手续费' };
      worksheet['A9'] = { v: this.tradeTotalData[0].amount };
      worksheet['B9'] = { v: this.tradeTotalData[0].price };
      worksheet['C9'] = { v: this.tradeTotalData[0].total };
      worksheet['D9'] = { v: this.tradeTotalData[0].fee };

      // 写入历史成交表
      worksheet['A11'] = { v: 'api' };
      worksheet['B11'] = { v: '成交时间' };
      worksheet['C11'] = { v: '交易对' };
      worksheet['D11'] = { v: '方向' };
      worksheet['E11'] = { v: '成交数量' };
      worksheet['F11'] = { v: '成交价格' };
      worksheet['G11'] = { v: '成交金额' };
      worksheet['H11'] = { v: '手续费' };
      worksheet['I11'] = { v: '计费币种' };

      for (let row = 0; row < this.tradeOriginData.length; row++) {
        worksheet[`A${row + 12}`] = { v: this.tradeOriginData[row].api };
        worksheet[`B${row + 12}`] = { v: this.tradeOriginData[row].time };
        worksheet[`C${row + 12}`] = { v: this.tradeOriginData[row].pair };
        worksheet[`D${row + 12}`] = { v: this.tradeOriginData[row].direction };
        worksheet[`E${row + 12}`] = { v: this.tradeOriginData[row].amount };
        worksheet[`F${row + 12}`] = { v: this.tradeOriginData[row].price };
        worksheet[`G${row + 12}`] = { v: this.tradeOriginData[row].total };
        worksheet[`H${row + 12}`] = { v: this.tradeOriginData[row].fee };
        worksheet[`I${row + 12}`] = { v: this.tradeOriginData[row].feeCurrency };
      }

      // 设置工作表的范围
      worksheet['!ref'] = `A1:I${this.tradeOriginData.length + 12}`;

      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      // 导出文件
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const fileData = new Blob([excelBuffer], { type: 'application/octet-stream' });
      FileSaver.saveAs(fileData, `${this.currency}统计数据报表.xlsx`);
    }
  },
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.apiStatsData.slice(start, end);
    }
  }
};
</script>

<style scoped>
.stats-page {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.stats-page h2 {
  color: #303133;
  margin-bottom: 10px;
}

.stats-page p {
  color: #606266;
  margin-bottom: 5px;
}

.stats-content {
  margin-top: 20px;
}

.section {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.section h3 {
  color: #303133;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 600;
}

/* 总统计卡片 */
.summary-cards {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.summary-card {
  flex: 1;
  min-width: 150px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 20px;
  color: white;
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.card-icon {
  font-size: 24px;
  margin-right: 10px;
}

.card-title {
  font-size: 14px;
  opacity: 0.9;
}

.card-value {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 8px;
}

.card-change {
  font-size: 14px;
  padding: 4px 10px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
}

.card-change.positive {
  background-color: rgba(0, 255, 0, 0.2);
}

.card-change.negative {
  background-color: rgba(255, 0, 0, 0.2);
}

.change-label {
  margin-left: 5px;
  font-size: 12px;
  opacity: 0.8;
}

/* API 统计表格 */
.api-stats-table {
  margin-top: 10px;
}

.change-positive {
  color: #67c23a;
}

.change-negative {
  color: #f56c6c;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>